import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import { AD_SLOTS } from 'components/AdSlots/AdSenseSlot';
import LazyHydration from 'components/LazyHydration';

import AdSenseSlot from './AdSenseSlot';

const MobileBannerAdSlot = ({
  className,
  showAdSlotOnBreakpoints = [true, null, false],
  slotId = AD_SLOTS.LANDSCAPE_320x50,
}) => (
  <LazyHydration className="block lg:hidden" placeholderSize={{ height: 50 }}>
    <AdSenseSlot
      className={twMerge('block lg:hidden', className)}
      height={50}
      showAdSlotOnBreakpoints={showAdSlotOnBreakpoints}
      slotId={slotId}
    />
  </LazyHydration>
);

MobileBannerAdSlot.displayName = 'MobileBannerAdSlot';

MobileBannerAdSlot.propTypes = {
  className: PropTypes.string,
  showAdSlotOnBreakpoints: PropTypes.array,
  slotId: PropTypes.string,
};

export default MobileBannerAdSlot;
